import type {SavedLoginAccount} from '@Libraries/login-signup-library';

/** The auth modal's bottom sheet (below 781) sets its titles one step smaller and always uses the compact gaps. */
export enum SavedAccountsLayout {
  STANDARD = 'standard',
  SHEET = 'sheet',
}

export interface SavedAccountsPanelProps {
  layout?: SavedAccountsLayout;
  onContinue: (account: SavedLoginAccount) => void;
  onUseAnotherAccount: () => void;
  /** Fired once the last remembered account has been removed; the host decides which panel follows. */
  onAllAccountsRemoved: () => void;
}
